import { render, staticRenderFns } from "./EditPassword1.vue?vue&type=template&id=b8236062&scoped=true"
import script from "./EditPassword1.vue?vue&type=script&lang=js"
export * from "./EditPassword1.vue?vue&type=script&lang=js"
import style0 from "./EditPassword1.vue?vue&type=style&index=0&id=b8236062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8236062",
  null
  
)

export default component.exports